export const LOCALE_STORAGE_KEY = 'portal-locale';
export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'es'];
